const EmptyChartIcon = () => (
  <svg
    width="160"
    height="120"
    viewBox="0 0 160 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M105.128 39.5544C105.093 39.7033 105.058 39.8609 105.023 40.0097C99.017 38.1537 92.232 36.5165 84.9919 35.2471C77.384 33.9164 70.1175 33.1197 63.5952 32.8483C63.6302 32.2355 63.709 31.6139 63.8404 31.001C65.7139 21.9486 76.4822 16.5207 87.8809 18.8845C99.2796 21.2482 107.01 30.502 105.128 39.5544V39.5544Z"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M67.9727 29.5915C68.4279 28.6022 69.0407 27.6742 69.7936 26.8425C71.6672 24.7589 74.3899 23.2006 77.6029 22.4214"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.5493 21.8348C84.0814 21.8348 85.6398 21.9924 87.1718 22.3163L82.5493 21.8348Z"
      fill="white"
    />
    <path
      d="M82.5493 21.8348C84.0814 21.8348 85.6398 21.9924 87.1718 22.3163"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.4093 55.3945C44.437 50.6573 34.6907 44.611 35.5529 39.7532C36.781 32.837 59.026 30.9163 85.2253 35.4726C111.433 40.0288 131.675 49.3309 130.447 56.2471C129.515 61.5011 116.441 63.8783 98.7169 62.7069"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M96.0023 108.149C79.7362 110.701 54.0608 107.431 40.3736 99.4459C39.5111 98.9407 39.241 97.8152 39.7724 96.9644L66.6589 46.8471C66.6589 46.8471 68.5321 43.5857 81.1738 45.7304C93.8068 47.8751 94.5648 51.5353 94.5648 51.5353L97.3092 104.356L97.4921 106.217C97.5793 107.156 96.9345 107.998 96.011 108.149H96.0023Z"
      fill="#E6FCEF"
    />
    <path
      d="M95.5 61L96.5 83"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M94.5879 51.7369C94.8999 49.8478 88.8764 47.2795 81.1339 46.0005C73.3915 44.7215 66.862 45.2162 66.5499 47.1053C66.2378 48.9944 72.2614 51.5626 80.0039 52.8416C87.7463 54.1206 94.2758 53.626 94.5879 51.7369Z"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M62.6487 49.9674C59.8235 48.3322 58.2675 46.5953 58.5283 45.0279C59.1629 41.2829 69.9681 39.9019 82.6509 41.9438C95.3425 43.9857 105.113 48.6796 104.47 52.433C104.174 54.1614 101.732 55.3815 97.9416 56"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M68.2883 91.2029L69.4956 78.1658C69.5486 77.5833 69.1144 77.0643 68.5319 77.0114L64.7828 76.6936C64.2003 76.6407 63.6919 77.0749 63.639 77.6468L62.4316 90.684C62.3787 91.2665 62.8129 91.7854 63.3954 91.8384L67.1445 92.1561C67.727 92.209 68.2353 91.7748 68.2883 91.2029Z"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.0587 91.9761L64.688 96.4242"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66.9324 73.6118L66.6782 76.556"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.1669 71.2379L83.9237 64.024C83.8449 63.5424 83.3809 63.2185 82.8994 63.3148L79.8353 63.8839C79.3625 63.9714 79.0561 64.4179 79.1349 64.8907L80.3781 72.1046C80.4569 72.5861 80.9209 72.91 81.4024 72.8137L84.4665 72.2447C84.9393 72.1571 85.2457 71.7106 85.1669 71.2379V71.2379Z"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.7598 72.5599L83.4426 76.1931"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.8945 60.951L81.341 63.3499"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.5 66C70.6046 66 71.5 65.1046 71.5 64C71.5 62.8954 70.6046 62 69.5 62C68.3954 62 67.5 62.8954 67.5 64C67.5 65.1046 68.3954 66 69.5 66Z"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.5 97C86.1569 97 87.5 95.6569 87.5 94C87.5 92.3431 86.1569 91 84.5 91C82.8431 91 81.5 92.3431 81.5 94C81.5 95.6569 82.8431 97 84.5 97Z"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.5 69L52.5 62"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M101.5 75L100.5 68"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.5 93L53.5 71"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M122.5 20L115.251 24.3274L118.326 26.8071L112.5 30"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M122.5 32L116.5 34"
      stroke="#00AB6B"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EmptyChartIcon;
